module.exports = __webpack_public_path__ + "static/media/cakaliko.kinsta.cloud.a15bdcab.png";